import { parseDuration } from 'util/datetime'
import { GraficoPadrao } from '../../components/GraficoPadraoPainel'
import _ from 'lodash'

export default function TMTGraficoPainel({ mediaAgrupadorList, fullName, nomeAgrupador, meta }) {
    let grupo = mediaAgrupadorList[0]
    let mediav = _.meanBy(grupo.apontamentos, (a) => parseFloat(_.get(a, 'resto', 0)));
    grupo.media = mediav + parseDuration(meta)

    return <GraficoPadrao mediaAgrupadorList={mediaAgrupadorList} fullName={fullName} nomeAgrupador={nomeAgrupador} meta={parseDuration(meta)} />
}